import { objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import classnames from '../../node_modules/classnames/index.js';
import { styled, Box } from '@mui/material';
import { createComponentSlot } from '../../modules/styling/theme.js';

var _excluded = ["className"];
var componentContent = createComponentSlot({
  name: "CinTileGrid",
  slot: "Content"
});

var TileGridContentBase = function TileGridContentBase(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Box, _extends({}, props, {
    className: classnames(componentContent.className, className)
  }));
};

var TileGridContent = styled(TileGridContentBase, _objectSpread2(_objectSpread2({}, componentContent.styledOptions), {}, {
  skipSx: true,
  skipVariantsResolver: true
}))({
  flexBasis: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center"
});
var TileGridContent$1 = TileGridContent;

export { TileGridContent$1 as default };
